import { websitesTargetService } from "../../../services/api/website-target.endpoints";
import store from "../../../store";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import {
  setMicroTargetList,
  setWebsiteTargetList,
} from "../../../features/websiteTargetSlice";

async function getAllWebsiteTarget(
  oauthTokenHeader: string,
  website_shared_uid: any,
  dispatch: any,
) {
  try {
    dispatch(setWebsiteTargetList([]));
    const response = await websitesTargetService.getAllWebsiteTarget(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      // throw new Error('Failed to get page content');
    } else {
      dispatch(setWebsiteTargetList(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getWebsiteMicroTargets(
  oauthTokenHeader: string,
  website_shared_uid: any,
  dispatch: any,
) {
  try {
    const response = await websitesTargetService.getWebsiteMicroTargets(
      oauthTokenHeader,
      website_shared_uid,
    );
    if (!response || !response.status || response.status !== 200) {
      // throw new Error('Failed to get page content');
    } else {
      dispatch(setMicroTargetList(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function postWebsiteTarget(
  oauthTokenHeader: string,
  data: any,
  setCreatedTargetUid: any,
  website_shared_uid: any,
) {
  try {
    const response = await websitesTargetService.postWebsiteTarget(
      oauthTokenHeader,
      data,
      website_shared_uid,
    );
    if (
      !response ||
      !response.status ||
      (response.status !== 200 && response.status !== 201)
    ) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating a new target', type: 'error' }));
      return response; // Return response even in error case
    } else {
      setCreatedTargetUid(response?.data?.data);
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Target created successfully",
          type: "success",
        }),
      );
      return response; // Return the response
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
    throw e; // Re-throw the error
  }
}

async function createWebsiteMicroTarget(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any,
) {
  try {
    const response = await websitesTargetService.postWebsiteMicroTarget(
      oauthTokenHeader,
      data,
      website_shared_uid,
    );
    if (!response || !response.status) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating a new target', type: 'error' }));
      throw new Error("Something went wrong while Creating a new target.");
    } else if (response.status === 200 || response.status === 201) {
      //store.dispatch(setDisplayErrorSnackBar({ message: 'Micro Target created successfully', type: 'success' }));
      return response?.data;
    }
  } catch (e: any) {
    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: e?.parsedText || "Unknown error occurred",
    //     type: "error",
    //   })
    // );
    // return e ? e?.parsedText : { reason: "Unknown error occurred." };
    return { reason: e?.parsedText || "Unknown error occurred" };
  }
}

async function updateWebsiteMicroTarget(
  oauthTokenHeader: string,
  data: any,
  websiteMicroTargetShareUID: any,
) {
  try {
    const response = await websitesTargetService.updateWebsiteMicroTarget(
      oauthTokenHeader,
      data,
      websiteMicroTargetShareUID,
    );
    if (!response || !response.status) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Template', type: 'error' }));
      throw new Error("Something went wrong while updating micro target.");
    } else if (response.status === 200) {
      //store.dispatch(setDisplayErrorSnackBar({ message: 'Website Micro Target updated successfully', type: 'success' }));
      return response?.data;
    }
  } catch (e: any) {
    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: e?.parsedText || "Unknown error occurred",
    //     type: "error",
    //   }),
    // );
    return e ? e?.parsedText : { reason: "Unknown error occurred." };
  }
}

async function getSingleWebsiteTarget(
  oauthTokenHeader: string,
  websiteSharedUID: string,
  websiteTargetShareUID: any,
  setWebsiteTargetData: any,
) {
  try {
    const response = await websitesTargetService.getSingleWebsiteTarget(
      oauthTokenHeader,
      websiteSharedUID,
      websiteTargetShareUID,
    );
    if (!response.status || response.status !== 200) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Template', type: 'error' }));
    } else {
      setWebsiteTargetData(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function updateWebsiteTarget(
  oauthTokenHeader: string,
  data: any,
  websiteTargetShareUID: any,
) {
  try {
    const response = await websitesTargetService.updateWebsiteTarget(
      oauthTokenHeader,
      data,
      websiteTargetShareUID,
    );
    if (!response.status || response.status !== 200) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Template', type: 'error' }));
      return response;
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: 'Website Target updated successfully', type: 'success' }));
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getGeo(oauthTokenHeader: string, setGeo: any) {
  try {
    const response = await websitesTargetService.getGeo(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Meta Territory",
          type: "error",
        }),
      );
    } else {
      setGeo(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getProductType(oauthTokenHeader: string, setProductType: any) {
  try {
    const response =
      await websitesTargetService.getProductType(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Meta Product Type",
          type: "error",
        }),
      );
    } else {
      setProductType(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

export const websiteTargetEndPointLogic = {
  getAllWebsiteTarget,
  getWebsiteMicroTargets,
  postWebsiteTarget,
  createWebsiteMicroTarget,
  updateWebsiteTarget,
  getGeo,
  getProductType,
  getSingleWebsiteTarget,
  updateWebsiteMicroTarget,
};
